import React, { useEffect, useState } from "react";

import PrimaryButton from "../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";

import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import TextField2T from "../textfields/TextField2T.js";

function NewInvoiceForm({
  setStep,
  article_configuration,
  mobile,
  setArticle_configuration,
  disabled = false,
}) {
  const updateConfigKey = (key, value) => {
    setArticle_configuration({ ...article_configuration, [key]: value });
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  return (
    <div className=" w-full max-w-c500 relative h-fit flex select-none ">
      {/* Left Column: Takes all available space */}

      <div className="flex flex-col gap-2 h-fit  w-full items-start justify-center  ">
        <DropDownGPT03
          force_down={true}
          className={"w-full"}
          value={article_configuration.timeline}
          onChange={(e) => updateConfigKey("timeline", e.value)}
          items={[
            { value: "pc", label: "Avant projet - Phase Permis de construire" },
            {
              value: "building",
              label: "En cours de construction",
            },
            {
              value: "existing",
              label: "Bâtiment existant",
            },
          ]}
          label="Avancement du projet"
        ></DropDownGPT03>
        <DropDownGPT03
          className={"w-full"}
          value={article_configuration.type}
          onChange={(e) => updateConfigKey("type", e.value)}
          items={[
            { value: "house", label: "Construction d'une maison" },
            {
              value: "extension",
              label: "Extension ou surélévation d'une maison",
            },
            { value: "renovation", label: "Rénovation" },
            { value: "tertiaire", label: "Tertiaire" },
            { value: "autre", label: "Autre" },
          ]}
          label="Type de projet"
        ></DropDownGPT03>
        {article_configuration.type === "extension" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface de l'extension'"
            ></TextField2T>
          </div>
        )}
        {article_configuration.type === "house" && (
          <div className="flex flex-col gap-2 w-full">
            <TextField2T
              value={article_configuration.units}
              onChange={(e) => {
                const newUnits = parseInt(e.target.value) || 1;
                const currentSurfaces = article_configuration.surfaces || [];
                let newSurfaces;
                if (newUnits > currentSurfaces.length) {
                  newSurfaces = [...currentSurfaces, ...Array(newUnits - currentSurfaces.length).fill("")];
                } else {
                  newSurfaces = currentSurfaces.slice(0, newUnits);
                }
                setArticle_configuration({
                  ...article_configuration,
                  units: e.target.value,
                  surfaces: newSurfaces,
                  surface: newSurfaces.reduce((a, b) => a + (parseFloat(b) || 0), 0).toString(),
                });
              }}
              placeholder="Nombre de maisons"
              type="number"
              label="Nombre de maisons"
            ></TextField2T>
            <div className="text-h4 text-gray-500 ml-1">Surface par maison</div>
            {(article_configuration.surfaces || [""]).map((s, i) => (
              <TextField2T
                key={i}
                value={s}
                onChange={(e) => {
                  const newSurfaces = [...(article_configuration.surfaces || [""])];
                  newSurfaces[i] = e.target.value;
                  setArticle_configuration({
                    ...article_configuration,
                    surfaces: newSurfaces,
                    surface: newSurfaces.reduce((a, b) => a + (parseFloat(b) || 0), 0).toString(),
                  });
                }}
                placeholder="Surface habitable"
                type="number"
                label={`Maison ${i + 1} - Surface (m²)`}
              ></TextField2T>
            ))}
          </div>
        )}{" "}
        {article_configuration.type === "house" && (
          <div className="flex flex-row gap-2 w-full   ">
            <DropDownGPT03
              className={"w-full"}
              value={article_configuration.author}
              onChange={(e) => updateConfigKey("author", e.value)}
              items={[
                { value: "locatif", label: "Au nom d'un particulier" },
                { value: "societe", label: "Au nom d'une société" },
              ]}
              label="Auteur de la demande"
            ></DropDownGPT03>
          </div>
        )}
        {article_configuration.type === "renovation" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface de la rénovation"
            ></TextField2T>
          </div>
        )}
        {article_configuration.type === "tertiaire" && (
          <div className="flex flex-row gap-2 w-full   ">
            <TextField2T
              value={article_configuration.surface}
              onChange={(e) => updateConfigKey("surface", e.target.value)}
              placeholder="Surface habitable"
              type="number"
              label="Surface du batiment"
            ></TextField2T>
          </div>
        )}
        {!disabled && (
          <div className="flex flex-row justify-end w-full">
            <PrimaryButton
              mobile={mobile}
              disabled={
                !article_configuration.timeline ||
                article_configuration.type === "" ||
                (article_configuration.type === "extension" &&
                  article_configuration.surface === "") ||
                (article_configuration.type === "house" &&
                  ((article_configuration.surfaces || []).some((s) => s === "" || s === "0") ||
                    article_configuration.units === "" ||
                    article_configuration.author === "")) ||
                (article_configuration.type === "renovation" &&
                  article_configuration.surface === "") ||
                (article_configuration.type === "tertiaire" &&
                  article_configuration.surface === "")
              }
              onClick={() => setStep("infos-1")}
              className="w-fit"
            >
              Valider
            </PrimaryButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewInvoiceForm;
